import { IntegrationAuthType } from 'modules/mobileApps/types';

export enum ModalType {
  AssignIntegrationModal = 'AssignIntegrationModal',
  ConfigureAndroidIntegrationModal = 'ConfigureAndroidIntegrationModal',
  ConfigureIosIntegrationModal = 'ConfigureIosIntegrationModal',
  ConfigureUnassignedIntegrationModal = 'ConfigureUnassignedIntegrationModal',
  DeleteAppModal = 'DeleteAppModal',
  DeleteIntegrationModal = 'DeleteIntegrationModal',
  TestPushModal = 'TestPushModal',
}

export type ModalProps = Partial<{
  /** Pass to `Configure*IntegrationModal` to dynamically render form fields. */
  authType: IntegrationAuthType;
  /** Name of the file uploaded to the Firebase form. */
  fileName: string;
  /** Pass to `TestPushModal` as true if user is opening the modal manually. */
  isTestingLater: boolean;

  onClose: () => void;
  onSubmit: () => void;
}>;

export type OpenedModal = {
  modalType: ModalType;
  modalProps?: ModalProps;
};

export type ModalContextState = {
  closeModal: (modalType: ModalType) => void;
  openedModals: OpenedModal[];
  openModal: (modalType: ModalType, modalProps?: ModalProps) => void;
};
